import React from 'react';
import { useMetaPixel } from '../hooks/useMetaPixel';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { IdentificationSection } from '../components/IdentificationSection';
import { SolutionSection } from '../components/SolutionSection';
import { ManualContents } from '../components/ManualContents';
import { SocialProof } from '../components/SocialProof';
import { ObjectionsSection } from '../components/ObjectionsSection';
import { OfferSection } from '../components/OfferSection';
import { SalesFooter } from '../components/SalesFooter';
export function SalesPage() {
  useMetaPixel();
  return <div className="min-h-screen bg-[#0A0A0A] text-[#D1D5DB] font-sans selection:bg-[#1A7A4A]/30" data-id="element-206">
      <UrgencyBar data-id="element-207" />
      <main data-id="element-208">
        <HeroSection data-id="element-209" />
        <PainSection data-id="element-210" />
        <IdentificationSection data-id="element-211" />
        <SolutionSection data-id="element-212" />
        <ManualContents data-id="element-213" />
        <SocialProof data-id="element-214" />
        <OfferSection data-id="element-215" />
        <ObjectionsSection data-id="element-216" />
      </main>
      <SalesFooter data-id="element-217" />
    </div>;
}